import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#with-borders" }),
  /*#__PURE__*/_createTextVNode(" With borders ")
], -1)
const _hoisted_3 = { class: "rounded border p-10" }
const _hoisted_4 = { style: {"margin-top":"20px"} }
const _hoisted_5 = { style: {"margin-top":"20px"} }
const _hoisted_6 = { style: {"margin-top":"20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", null, [
        _createVNode(_component_el_checkbox, {
          modelValue: _ctx.checked1,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.checked1 = $event)),
          label: "Option1",
          border: ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_checkbox, {
          modelValue: _ctx.checked2,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.checked2 = $event)),
          label: "Option2",
          border: ""
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_el_checkbox, {
          modelValue: _ctx.checked3,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.checked3 = $event)),
          label: "Option1",
          border: "",
          size: "medium"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_checkbox, {
          modelValue: _ctx.checked4,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.checked4 = $event)),
          label: "Option2",
          border: "",
          size: "medium"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_el_checkbox_group, {
          modelValue: _ctx.checkboxGroup1,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.checkboxGroup1 = $event)),
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox, {
              label: "Option1",
              border: ""
            }),
            _createVNode(_component_el_checkbox, {
              label: "Option2",
              border: "",
              disabled: ""
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_el_checkbox_group, {
          modelValue: _ctx.checkboxGroup2,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.checkboxGroup2 = $event)),
          size: "mini",
          disabled: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox, {
              label: "Option1",
              border: ""
            }),
            _createVNode(_component_el_checkbox, {
              label: "Option2",
              border: ""
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code6), 1)
        ]),
        _: 1
      })
    ])
  ]))
}